import { dispatch } from "@/redux/index";
import { fetchPatient } from "@/redux/thunks/patients.thunk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { assignResourceToPatient, removeResource, sendResource } from "../../services/patient/patient.service";
import { updateResourcesFromYoutube } from "../../services/resources/youtube.service";
import { getResourcesByPatient } from "../../services/youtube/youtube.service";

export const updateResourcesYoutube = createAsyncThunk(
  'resource/updateResourcesYoutube',  
  async ({patient_id}: {patient_id: string}, thunkAPI) => {    
    try {
      const data: any = await updateResourcesFromYoutube();
      return await dispatch(fetchResources({patient_id}));
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);

export const fetchResources = createAsyncThunk(
  'resource/fetchResources',  
  async ({patient_id}: {patient_id: string}, thunkAPI) => {    
    try {
      const data: any = await getResourcesByPatient(patient_id);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);

export const uploadResource = createAsyncThunk(
  'resource/uploadResource',  
  async ({patient_id, data}: {patient_id: string, data: FormData}, thunkAPI) => {    
    try {
      const res: any = await sendResource(patient_id, data);
      return await dispatch(fetchResources({patient_id}));
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);

export const deleteResource = createAsyncThunk(
  'resource/deleteResource',  
  async ({patient_id, path, type}: {patient_id: string, path: string, type: string}, thunkAPI) => {    
    try {
      const res: any = await removeResource(patient_id, path, type);
      return await dispatch(fetchResources({patient_id}));
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);

export const assignResource = createAsyncThunk(
  'resource/assignResource',  
  async ({patient_id, resources}: {patient_id: string, resources: any[]}, thunkAPI) => {    
    try {
      const res: any = await assignResourceToPatient(patient_id, resources);
      return await dispatch(fetchPatient({patient_id}));
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);